/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { Autocomplete } from "@material-ui/lab";
import InputMask from "react-input-mask";
import { BeatLoader } from "react-spinners";
import * as Styles from "../../styles";
import { AuthState } from "../../../../store/ducks/auth/types";
import { useTiposEmpreendimentos } from "../../../../services/api/Mobile_Tipos_Empreendimentos/tipos-empreendimentos";
import { useListarPrazosEntregasImovel } from "../../../../services/api/Mobile_Prazos_Entrega_Imovel/prazos-entrega-imovel";
import { useListarZonasEmpreendimentos } from "../../../../services/api/Mobile_Zonas_Empreendimentos/zonas_empreendimentos";
import { useListarBairrosEmpreendimentos } from "../../../../services/api/AppWeb_Bairros_Empreendimentos/bairros_empreendimentos";
import { useAlterarPreferencias } from "../../../../services/api/AppWeb_Lead/alterar-preferencias";
import QtdDomitorios from "../../../QtdDomitorios";
import { useListarEmpreendimentos2 } from "../../../../services/api/AppWeb_Empreendimento2";

interface PrerenciaProps {
  idLeadCorretor: string | null;
  idLead: string | null;
  idTipoEmpreendimento: string | null;
  tipoEmpreendimento: string | null;
  idPrazoEntregaImovel: string | null;
  prazoEntregaImovel: string | null;
  inicioIntervaloMetragemImovel: string | null;
  fimIntervaloMetragemImovel: string | null;
  inicioIntervaloValorImovel: string | null;
  fimIntervaloValorImovel: string | null;
  zonaImovel: any;
  bairroImovel: string | null;
}

interface Props {
  closeModal: () => void;
  idLeadCorretor: string;
  preferenciasLead: PrerenciaProps | any;
  refetch: () => void;
  refetchDataLead: () => void;
  readOnly?: boolean;
}

const PreferenciasDoLeadForm: React.FC<Props> = (props) => {
  const { codigoCargo2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const isCorretor =
    codigoCargo2013 === "219.840.002" ||
    codigoCargo2013 === "219.840.012" ||
    codigoCargo2013 === "219.840.001";
  const isDisabled = props.readOnly === true;

  const {
    data: dataTiposEmpreendimentos,
    refetch: refetchTiposEmpreendimentos,
  } = useTiposEmpreendimentos();
  const [tipoEmpreendimentos, setTipoEmpreendimentos] = useState<{
    id: string | null;
    nome: string | null;
  } | null>(null);
  const { data: dataPrazosEntregasimovel, refetch: refetchPrazosEntregas } =
    useListarPrazosEntregasImovel();
  const [prazoEntrega, setPrazoEntrega] = useState<{
    id: string | null;
    nome: string | null;
  } | null>(null);
  const [inicioIntervaloMetragemImovel, setInicioIntervaloMetragemImovel] =
    useState("");
  const [fimIntervaloMetragemImovel, setFimIntervaloMetragemImovel] =
    useState("");
  const [inicioValorImovel, setInicioValorImovel] = useState("");
  const [fimValorImovel, setFimValorImovel] = useState("");
  const {
    data: dataZonasEmpreendimentos,
    refetch: refetchZonasEmpreendimentos,
  } = useListarZonasEmpreendimentos();
  const [zonas, setZonas] = useState<any>([]);
  const [bairros, setBairros] = useState<any>([]);
  const [qtdDormitorios, setQtdDormitorios] = useState<number[]>([]);
  const [empreendimentolist, setEmpreendimentoList] = useState([]);
  const [empreendimentos, setEmpreendimentos] = useState<any>([]);
  const { data: dataEmpreendimentos2, refetch: refetchEmpreendimentos } =
    useListarEmpreendimentos2();

  const setLeadData = () => {
    if (props?.preferenciasLead) {
      if (props?.preferenciasLead?.empreendimentos) {
        setEmpreendimentos(
          props?.preferenciasLead?.empreendimentos?.map(
            (item: { nome: string; id: string }) => ({
              label: item?.nome,
              value: item?.id,
            })
          )
        );
      }
      if (props?.preferenciasLead?.quantidadeDormitorios) {
        setQtdDormitorios(props?.preferenciasLead?.quantidadeDormitorios);
      }
      if (props?.preferenciasLead?.idTipoEmpreendimento) {
        setTipoEmpreendimentos({
          nome: props?.preferenciasLead?.tipoEmpreendimento,
          id: props?.preferenciasLead?.idTipoEmpreendimento,
        });
      }
      if (props?.preferenciasLead?.idPrazoEntregaImovel) {
        setPrazoEntrega({
          nome: props?.preferenciasLead?.prazoEntregaImovel,
          id: props?.preferenciasLead?.idPrazoEntregaImovel,
        });
      }
      if (props?.preferenciasLead?.zonaImovel) {
        setZonas(
          props?.preferenciasLead?.zonaImovel
            ? props?.preferenciasLead?.zonaImovel?.map(
                (item: { nome: string; id: string }) => ({
                  label: item?.nome,
                  value: item?.id,
                })
              )
            : { label: "", value: "" }
        );
      }
      if (props?.preferenciasLead?.inicioIntervaloMetragemImovel) {
        setInicioIntervaloMetragemImovel(
          props?.preferenciasLead?.inicioIntervaloMetragemImovel?.toString()
        );
      }
      if (props?.preferenciasLead?.fimIntervaloMetragemImovel) {
        setFimIntervaloMetragemImovel(
          props?.preferenciasLead?.fimIntervaloMetragemImovel?.toString()
        );
      }
      if (props?.preferenciasLead?.inicioIntervaloValorImovel) {
        setInicioValorImovel(
          formatCurrency(props?.preferenciasLead?.inicioIntervaloValorImovel)
        );
      }
      if (props?.preferenciasLead?.fimIntervaloValorImovel) {
        setFimValorImovel(
          formatCurrency(
            props?.preferenciasLead?.fimIntervaloValorImovel?.toString()
          )
        );
      }
      if (props?.preferenciasLead?.bairroImovel) {
        setBairros(
          props?.preferenciasLead?.bairroImovel
            ? props?.preferenciasLead?.bairroImovel?.map(
                (item: { nome: string; id: string }) => ({
                  label: item?.nome,
                  value: item?.id,
                })
              )
            : []
        );
      }
    }
  };

  useEffect(() => {
    if (props?.preferenciasLead) {
      refetchTiposEmpreendimentos();
      refetchPrazosEntregas();
      refetchZonasEmpreendimentos();
      setLeadData();
      refetchEmpreendimentos();
    }
  }, []);

  useEffect(() => {
    if (dataEmpreendimentos2) {
      setEmpreendimentoList(
        dataEmpreendimentos2?.data?.map(
          (item: { nome: string; id: string }) => ({
            label: item?.nome,
            value: item?.id,
          })
        )
      );
    }
  }, [dataEmpreendimentos2]);

  const { mutate, data: dataBairrosEmpreendimentos } =
    useListarBairrosEmpreendimentos({
      idsZonasEmpreendimento: zonas?.map((item: any) => item?.value),
    });
  const [bairrosList, setBairrosList] = useState(
    dataBairrosEmpreendimentos?.data?.data
      ? dataBairrosEmpreendimentos?.data?.data?.map((item: any) => ({
          label: item?.nome,
          value: item?.idBairro,
        }))
      : []
  );

  useEffect(() => {
    if (dataBairrosEmpreendimentos) {
      setBairrosList(
        dataBairrosEmpreendimentos?.data?.data?.map(
          (item: { nome: string; idBairro: string }) => ({
            label: item?.nome,
            value: item?.idBairro,
          })
        )
      );
    }
  }, [dataBairrosEmpreendimentos]);

  useEffect(() => {
    if (zonas?.length > 0) {
      mutate();
    }
  }, [zonas]);

  const handleInputChange = (event: any, setStateFunction: any) => {
    const inputValue = event.target.value;
    const formattedValue = formatCurrency(inputValue);
    setStateFunction(formattedValue);
  };

  const formatCurrency = (value: any) => {
    const numericValue = value?.replace(/[^0-9,]/g, "");
    const [integerPart, decimalPart] = numericValue?.split(",");
    let formattedValue = integerPart?.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    if (decimalPart) {
      formattedValue += `,${decimalPart?.slice(0, 2)}`;
    }

    return formattedValue;
  };

  const {
    mutate: mutateAlterarPreferencias,
    isSuccess: isSuccessPreferencias,
    isLoading: isLoadingPreferencias,
  } = useAlterarPreferencias({
    idLeadCorretor: props?.idLeadCorretor,
    body: {
      idLead: props?.preferenciasLead?.idLead,
      idTipoEmpreendimento: tipoEmpreendimentos?.id || null,
      inicioIntervaloValorImovel: inicioValorImovel,
      fimIntervaloValorImovel: fimValorImovel,
      inicioIntervaloMetragemImovel: parseFloat(inicioIntervaloMetragemImovel),
      fimIntervaloMetragemImovel: parseFloat(fimIntervaloMetragemImovel),
      quantidadesDormitorios: qtdDormitorios,
      idPrazoEntregaImovel: prazoEntrega?.id || null,
      idsZonasEmpreendimentos: zonas?.map((item: any) => item?.value),
      idsBairrosEmpreendimentos: bairros?.map((item: any) => item?.value),
      idsEmpreendimentos: empreendimentos?.map((item: any) => item?.value),
    },
    refetchDataLead: () => props.refetchDataLead(),
  });

  const handleSubmit = () => {
    mutateAlterarPreferencias();
  };

  useEffect(() => {
    if (isSuccessPreferencias) {
      props?.closeModal();
    }
  }, [isSuccessPreferencias]);

  return (
    <>
      <Styles.RowGap>
        <Styles.Column>
          <Styles.LabelText>Produtos</Styles.LabelText>
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={empreendimentolist}
            size="small"
            disabled={isDisabled}
            disableCloseOnSelect
            filterSelectedOptions
            value={empreendimentos}
            getOptionLabel={(option) => option?.label || ""}
            getOptionSelected={(option, value) =>
              option?.label === value?.label
            }
            onChange={(event, newValue: any) => {
              setEmpreendimentos(newValue);
            }}
            style={{
              color: "#D0D5DD",
            }}
            renderInput={(params) => (
              <Styles.TextField
                variant="outlined"
                {...params}
                label="Resultado *"
                required
                fullWidth
              />
            )}
          />
        </Styles.Column>
      </Styles.RowGap>
      <Styles.SpaceY space={8} />
      <Styles.RowGap>
        <Styles.Column>
          <Styles.LabelText>Tipo de empreendimento</Styles.LabelText>
          <Styles.Autocomplete
            id="combo-box-demo"
            fullWidth
            disabled={isDisabled}
            options={
              dataTiposEmpreendimentos?.data
                ? dataTiposEmpreendimentos?.data
                : []
            }
            value={tipoEmpreendimentos}
            renderInput={(params: any) => (
              <>
                <Styles.TextField
                  size="small"
                  InputLabelProps={{ shrink: false }}
                  variant="outlined"
                  {...params}
                  label="Resultado *"
                  required
                  fullWidth
                />
              </>
            )}
            getOptionSelected={(option: any) => option?.nome}
            getOptionLabel={(option: any) => option?.nome || ""}
            // @ts-ignore
            onChange={(
              event: any,
              newValue: {
                id: string | null;
                nome: string | null;
              } | null
            ) => {
              setTipoEmpreendimentos(newValue);
            }}
          />
        </Styles.Column>
        <Styles.Column>
          <Styles.LabelText>Prazo de entrega</Styles.LabelText>
          <Styles.Autocomplete
            id="combo-box-demo"
            fullWidth
            disabled={isDisabled}
            options={
              dataPrazosEntregasimovel?.data
                ? dataPrazosEntregasimovel?.data
                : []
            }
            value={prazoEntrega}
            renderInput={(params: any) => (
              <>
                <Styles.TextField
                  size="small"
                  InputLabelProps={{ shrink: false }}
                  variant="outlined"
                  {...params}
                  label="Resultado *"
                  required
                  fullWidth
                />
              </>
            )}
            getOptionSelected={(option: any) => option?.nome}
            getOptionLabel={(option: any) => option?.nome || ""}
            // @ts-ignore
            onChange={(
              event: any,
              newValue: {
                id: string | null;
                nome: string | null;
              } | null
            ) => {
              setPrazoEntrega(newValue);
            }}
          />
        </Styles.Column>
      </Styles.RowGap>
      <Styles.SpaceY space={8} />
      <Styles.RowGap>
        <Styles.Column>
          <Styles.LabelText>Metragem imóvel</Styles.LabelText>
          <Styles.RowNoPd>
            <Styles.TextField
              size="small"
              InputLabelProps={{ shrink: false }}
              variant="outlined"
              label="Data *"
              fullWidth
              disabled={isDisabled}
              onChange={(e: any) =>
                setInicioIntervaloMetragemImovel(
                  e.target.value?.substring(0, 4).replace(/\D/g, "")
                )
              }
              value={inicioIntervaloMetragemImovel}
            />
            <div
              style={{
                fontFamily: "Inter",
                fontSize: 14,
                color: "#333",
                marginLeft: 8,
                marginRight: 8,
              }}
            >
              Até
            </div>
            <Styles.TextField
              size="small"
              InputLabelProps={{ shrink: false }}
              variant="outlined"
              label="Data *"
              fullWidth
              disabled={isDisabled}
              onChange={(e: any) =>
                setFimIntervaloMetragemImovel(
                  e.target.value?.substring(0, 4).replace(/\D/g, "")
                )
              }
              value={fimIntervaloMetragemImovel}
            />
          </Styles.RowNoPd>
        </Styles.Column>
        <Styles.Column>
          <Styles.LabelText>Valor imóvel</Styles.LabelText>
          <Styles.RowNoPd>
            <Styles.TextField
              size="small"
              InputLabelProps={{ shrink: false }}
              variant="outlined"
              label="Data *"
              fullWidth
              disabled={isDisabled}
              onChange={(event) =>
                handleInputChange(event, setInicioValorImovel)
              }
              value={inicioValorImovel}
            />
            <div
              style={{
                fontFamily: "Inter",
                fontSize: 14,
                color: "#333",
                marginLeft: 8,
                marginRight: 8,
              }}
            >
              Até
            </div>
            <Styles.TextField
              size="small"
              InputLabelProps={{ shrink: false }}
              variant="outlined"
              label="Data *"
              fullWidth
              disabled={isDisabled}
              onChange={(event) => handleInputChange(event, setFimValorImovel)}
              value={fimValorImovel}
            />
          </Styles.RowNoPd>
        </Styles.Column>
      </Styles.RowGap>
      <Styles.SpaceY space={8} />
      <Styles.RowGap>
        <Styles.Column>
          <Styles.LabelText>Zonas</Styles.LabelText>
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={
              dataZonasEmpreendimentos
                ? dataZonasEmpreendimentos?.data?.map(
                    (item: { nome: string; id: string }) => ({
                      label: item?.nome,
                      value: item?.id,
                    })
                  )
                : []
            }
            size="small"
            disabled={isDisabled}
            disableCloseOnSelect
            filterSelectedOptions
            value={zonas}
            getOptionLabel={(option) => option?.label || ""}
            getOptionSelected={(option, value) =>
              option?.label === value?.label
            }
            onChange={(event, newValue: any) => {
              setZonas(newValue);
            }}
            style={{
              color: "#D0D5DD",
            }}
            renderInput={(params) => (
              <Styles.TextField
                variant="outlined"
                {...params}
                label="Resultado *"
                required
                fullWidth
              />
            )}
          />
        </Styles.Column>
        <Styles.Column>
          <Styles.LabelText>Bairros</Styles.LabelText>
          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            options={bairrosList}
            size="small"
            disabled={isDisabled}
            disableCloseOnSelect
            filterSelectedOptions
            value={bairros}
            getOptionLabel={(option) => option?.label || ""}
            getOptionSelected={(option, value) =>
              option?.label === value?.label
            }
            onChange={(event, newValue: any) => {
              setBairros(newValue);
            }}
            style={{
              color: "#D0D5DD",
            }}
            renderInput={(params) => (
              <Styles.TextField
                variant="outlined"
                {...params}
                label="Resultado *"
                required
                fullWidth
              />
            )}
          />
        </Styles.Column>
      </Styles.RowGap>
      <Styles.SpaceY space={8} />
      <Styles.RowGap>
        <Styles.Column>
          <Styles.LabelText>Dormitórios</Styles.LabelText>
          <QtdDomitorios
            value={qtdDormitorios}
            disabled={isDisabled}
            onValueChange={(val) => setQtdDormitorios(val)}
          />
        </Styles.Column>
      </Styles.RowGap>

      <Styles.FooterDialog>
        <Styles.Button
          style={{ width: "100%" }}
          variant="outlined"
          onClick={() => {
            props.closeModal();
          }}
        >
          Fechar
        </Styles.Button>
        {isCorretor && !isDisabled ? (
          <Styles.SaveButton
            onClick={() => handleSubmit()}
            style={{
              width: "100%",
              background: "#4a76fb",
              boxShadow: "none",
              color: "#fff !important",
            }}
          >
            {isLoadingPreferencias ? (
              <BeatLoader color="#fff" size={10} />
            ) : (
              "Salvar"
            )}
          </Styles.SaveButton>
        ) : null}
      </Styles.FooterDialog>
    </>
  );
};

export default PreferenciasDoLeadForm;
